<template>
    <service-level :type="0"></service-level>
</template>

<script>
    import ServiceLevel from '../service/level.vue'

    export default {
        name: 'companyServiceLevel',
        components: {
            ServiceLevel
        },
        data() {
            return {
            }
        },
        mounted() {
            
        },
        methods: {
        }
    }
</script>
